import React, { useContext } from 'react'
import { CloseDiv, Container, Header, InfosContainer, RowDatas} from './style'
import close from '../../../assets/close-icon.svg'
import ModalContext from '../../../contexts/ModalContext'
import { fieldsAndValues } from './utils'
import { ReportContext } from '../../../contexts/ReportContext'

const CheckReportModal:React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const { report } = useContext(ReportContext)
  console.log(report)
 
  return(
    <Container>
      <Header>
        <h2>Ordem de serviço: {report?.id}</h2>
        <CloseDiv onClick={() => (setModalActive(false))}>
          <img src={close} />
        </CloseDiv>
      </Header>
      <InfosContainer>
        {fieldsAndValues.map((item, index) => (
          <RowDatas key={index}>
            {item.label}:
            <span>{report[item.value]}</span>
          </RowDatas>
        ))}
      </InfosContainer>
    </Container>
  )
}

export default CheckReportModal